import React from "react"
import "./workHeader.css"
import Navbar from "./navbar"

export default props => {
  const lang = props.navLang
  return (
    <div id="workHeader-background">
      <Navbar lang={lang} pageUrl={props.pageUrl} />
      <div id="workHeader-strip">
        <div id="workHeader-holder">
          <img src={props.pic} alt="project look" />
          <div>
            <h2 id="work-title">
              <span
                style={{
                  background:
                    "linear-gradient(to bottom, transparent 65%, " +
                    props.hl +
                    " 10%)",
                }}
              >
                {props.title}
              </span>
            </h2>
            <h4>{props.subTitle}</h4>
          </div>
        </div>
      </div>
    </div>
  )
}
